/**
 * String values
 * If applicable - string variables should contain variations ENABLED, DISABLED for consistency purposes
 * For multivalued variations - use comma to separate values.
 * Example:
 *  Variation 1: "ENABLED"
 *  Variation 2: "DISABLED"
 *  Variation 3: "VALUE_A"
 *  Variation 4: "VALUE_B"
 *  Variation 5: "VALUE_C"
 *  Variation 6: "VALUE_A,VALUE_C"
 *
 */
export enum LaunchDarklyStringFeatureFlagKeys {
  financeQuickView = 'financeQuickView',
  auditReportCards = 'auditReportCards',
  sentrySamplingRateBpeWeb = 'sentrySamplingRateBpeWeb'
}

export interface LaunchDarklyStringFeatureFlags {
  [LaunchDarklyStringFeatureFlagKeys.financeQuickView]:
    | 'ENABLED'
    | 'DISABLED'
    | 'EXPENSES'
    | 'INVOICES'
    | 'TIMESHEETS'
    | 'TIMESHEETS,EXPENSES'
    | 'TIMESHEETS,INVOICES'
    | 'EXPENSES,INVOICES';

  [LaunchDarklyStringFeatureFlagKeys.auditReportCards]: string;
  [LaunchDarklyStringFeatureFlagKeys.sentrySamplingRateBpeWeb]: string;
}
